import React from "react";
// javascript plugin used to create scrollbars on windows
import { Route, Switch } from "react-router-dom";

import Navigation from "components/Navbars/Navigation";
import { Container } from "reactstrap";

//Routes
import routes from "../routes/routes";
import LogoSistema from "../components/LogoSistema/LogoSistema";

class Auth extends React.Component {
  constructor(props) {
    super(props);

    if (!localStorage.getItem('firstAccess')) {
      localStorage.setItem('firstAccess', 'true');
    }
  }

  render() {
    return (
      <div>
        <div className="content-auth" style={{ background: "#F8F8F8" }}>
          <Navigation />
          <Container className="margin-auth">
            <Switch>
              {routes.map((prop, key) => {
                return (
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          </Container>
        </div>
        <footer
          className="py-2"
          style={{
            background: "#FFFFFF",
            borderTop: "1px solid black",
            position: "fixed",
            bottom: "0",
            left: "0",
            right: "0",
            zIndex: "99999"
          }}
        >
          <div className="w-100 d-flex align-items-center justify-content-end gap-3 px-2">
            <div className="bg-white rounded p-1" style={{ height: "50px" }}>
              <LogoSistema identificacaoLogo={"logoSecundario"} width={"80px"} style={{ maxHeight: "50px" }}/>
            </div>
            <div className="bg-white rounded p-1 mr-2" style={{ height: "50px" }}>
              <LogoSistema identificacaoLogo={"logotipo"} style={{ maxHeight: "50px" }} />
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Auth;
